module.exports = __webpack_public_path__ + "img/footer_bg.8982473c.png";